const value
= {
  "type": "group",
  "id": "9a99988a-0123-4456-b89a-b1607f326fd8",
  "children1": [
    {
      "id": "a98ab9b9-cdef-4012-b456-71607f326fd9",
      "type": "rule",
      "properties": {
        "field": "user.login",
        "operator": "equal",
        "value": [
          "batman"
        ],
        "valueSrc": [
          "value"
        ],
        "valueType": [
          "text"
        ]
      }
    },
    {
      "id": "98a8a9ba-0123-4456-b89a-b16e721c8cd0",
      "type": "rule",
      "properties": {
        "field": "stock",
        "operator": "equal",
        "value": [
          false
        ],
        "valueSrc": [
          "value"
        ],
        "valueType": [
          "boolean"
        ]
      }
    },
    {
      "id": "aabbab8a-cdef-4012-b456-716e85c65e9c",
      "type": "rule",
      "properties": {
        "field": "slider",
        "operator": "equal",
        "value": [
          35
        ],
        "valueSrc": [
          "value"
        ],
        "valueType": [
          "number"
        ]
      }
    }
  ],
  "properties": {
    "conjunction": "AND",
    "not": false
  }
};
export default value;
